module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Warning-2-ace504ea1a3c8dbc3bffbd413f82a9e1.svg";